module.exports = __webpack_public_path__ + "static/media/DinersClub.26d59780.svg";